import React, { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import moment from "moment";
import _ from "lodash";

import TimePicker from "../components/TimePicker";
import {
  set_team_opts,
  set_event_details,
  set_custom_opt_types,
  set_create_opt_phase
} from "../../../redux/opt/action";
import { setIsLoading } from "../../../redux/loader/action";
import { ReactComponent as DownArrowSvg } from "../../../assets/images/opt/down-arrow.svg";
import { ReactComponent as BroSvg } from "../../../assets/images/opt/bro.svg";
import { ReactComponent as AddTypeSvg } from "../../../assets/images/opt/add-type.svg";
import { ReactComponent as DeleteTypeSvg } from "../../../assets/images/opt/delete-type.svg";
import { ReactComponent as DeleteIconSvg } from "../../../assets/images/opt/delete-icon.svg";
import { ReactComponent as DummyAvatarSvg } from "../../../assets/images/opt/dummy-avatar.svg";
import { ReactComponent as CheckBoxEnabledSvg } from "../../../assets/images/opt/checkbox-enabled.svg";
import { ReactComponent as CheckBoxDisabledSvg } from "../../../assets/images/opt/checkbox-disabled.svg";
import Socket from "../../../socket/socket";

const AddEvent = ({
  users,
  history,
  teamMembers,
  selectedUsers,
  setTeamMembers,
  onTeamModalOpen,
  setSelectedUsers,
  add_event_params,
  onDeleteModalOpen
}) => {
  const {
    optReducer: {
      team_opts,
      opt_details,
      event_details,
      custom_opt_types,
      create_opt_phase
    },
    gameReducer: { currentUser }
  } = useSelector((state) => state);

  const primary_text_add = _.get(
    add_event_params,
    "primary_text_add",
    "Create New Event"
  );

  const secondary_text_add = _.get(
    add_event_params,
    "secondary_text_add",
    "Add a new event, record participation, and filters for reporting."
  );
  const back_btn = _.get(add_event_params, "back_btn", "Back");
  const create_btn = _.get(add_event_params, "create_btn", "Create");
  const primary_text_edit = _.get(
    add_event_params,
    "primary_text_edit",
    "Edit Event"
  );
  const secondary_text_edit = _.get(
    add_event_params,
    "secondary_text_edit",
    "Edit an existing Team Building event."
  );
  const save_btn = _.get(add_event_params, "save_btn", "Save");
  const title_hint = _.get(add_event_params, "title_hint", "Event Title");
  const duration_text = _.get(
    add_event_params,
    "duration_text",
    "Event Duration"
  );
  const start_date_hint = _.get(
    add_event_params,
    "start_date_hint",
    "Start Date"
  );
  const start_time_hint = _.get(
    add_event_params,
    "start_time_hint",
    "Start Time"
  );

  const end_date_hint = _.get(add_event_params, "end_date_hint", "End Date");
  const end_time_hint = _.get(add_event_params, "end_time_hint", "End Time");
  const details_text = _.get(add_event_params, "details_text", "Event Details");
  const type_hint = _.get(add_event_params, "type_hint", "Event Type");
  const category_hint = _.get(
    add_event_params,
    "category_hint",
    "Event Category"
  );
  const participants_text = _.get(
    add_event_params,
    "participants_text",
    "Event Participants"
  );
  const add_teammates_btn = _.get(
    add_event_params,
    "add_teammates_btn",
    "Add Teammates"
  );
  const empty_text = _.get(
    add_event_params,
    "empty_text",
    "No Teammates to display. Add Teammates to record attendance for your event."
  );
  const table_col_1 = _.get(add_event_params, "table_col_1", "Teammate");
  const table_col_2 = _.get(add_event_params, "table_col_2", "Email");
  const table_col_3 = _.get(add_event_params, "table_col_3", "Team");
  const default_text = _.get(
    add_event_params,
    "default_text",
    "Default (Unassigned)"
  );
  const type_array = _.get(add_event_params, "type_array", [
    "Happy Hour",
    "Holiday Pary",
    "Team Building Exercise",
    "Team/Company Offsite",
    "Team Meal"
  ]);
  const categories_array = _.get(add_event_params, "categories_array", [
    "Collaboration",
    "Communication",
    "Competition",
    "Cooperation",
    "Wellness"
  ]);

  const other_text = _.get(add_event_params, "other_text", "Other:");
  const other_input = _.get(
    add_event_params,
    "other_input",
    "Add an Event Type"
  );

  const dispatch = useDispatch();

  const firstUpdate = useRef(true);
  const [dropdown, setDropdown] = useState({
    start_date: false,
    end_date: false,
    start_time: false,
    end_time: false,
    event_type: false,
    event_category: false,
    select_teammates: false
  });

  // const [event_details, setEventDetails] = useState({
  //   title: "",
  //   start_date: "",
  //   end_date: "",
  //   start_time: "",
  //   end_time: "",
  //   start_timestamp: "",
  //   end_timestamp: "",
  //   type: "",
  //   category: "",
  //   participants: []
  // });
  const [startTimeDetails, setStartTimeDetails] = useState({
    hour: { value: "", index: null },
    minutes: { value: "", index: null },
    type: ""
  });
  const [endTimeDetails, setEndTimeDetails] = useState({
    hour: { value: "", index: null },
    minutes: { value: "", index: null },
    type: ""
  });
  const [customEventType, setCustomEventType] = useState("");

  useEffect(() => {
    if (!_.isEmpty(opt_details)) {
      const selected_users = users.filter((user) => {
        return opt_details.participants.some(
          (item) => item.user_id === user.Username
        );
      });
      setSelectedUsers(selected_users);

      const selected_members = users.map((user) => ({
        ...user,
        selected: opt_details.participants.some(
          (item) => item.user_id === user.Username
        )
      }));

      setTeamMembers(selected_members);

      dispatch(
        set_event_details({
          ...event_details,
          title: opt_details.title,
          start_date: moment(opt_details.start_timestamp)
            .startOf("day")
            .format(),
          end_date: moment(opt_details.end_timestamp).startOf("day").format(),
          start_time: moment(opt_details.start_timestamp).format("hh:mm A"),
          end_time: moment(opt_details.end_timestamp).format("hh:mm A"),
          start_timestamp: opt_details.start_timestamp,
          end_timestamp: opt_details.end_timestamp,
          type: opt_details.type,
          category: opt_details.category,
          participants: opt_details.participants
        })
      );
    }
  }, [users, opt_details]);

  const handleToggleLoading = (value) => {
    dispatch(setIsLoading(value));
  };

  useEffect(() => {
    return Socket.addListener(
      "opt-create",
      handle_opt_create,
      handle_opt_error
    );
  }, []);

  const handle_opt_create = (res) => {
    if (res) {
      dispatch(set_team_opts([...team_opts, res.opt]));
      handleToggleLoading(false);
      dispatch(set_create_opt_phase("one"));
      history.push("/outside_team_building");
    }
  };

  useEffect(() => {
    return Socket.addListener(
      "opt-update",
      handle_opt_update,
      handle_opt_error
    );
  }, []);

  const handle_opt_update = (res) => {
    if (res) {
      let array = team_opts.filter((opt) => opt.opt_id !== res.opt.opt_id);
      array.push(res.opt);
      dispatch(set_team_opts(array));
      handleToggleLoading(false);
      dispatch(set_create_opt_phase("one"));
      history.push("/outside_team_building");
    }
  };

  const handle_opt_error = () => {
    handleToggleLoading(false);
  };

  useEffect(() => {
    return Socket.addListener(
      "opt-options",
      handle_opt_options,
      handle_opt_options_error
    );
  }, [custom_opt_types]);

  const handle_opt_options = (res) => {
    if (res) {
      setCustomEventType("");
      dispatch(set_custom_opt_types(res.opt_types));
      handleToggleLoading(false);
    }
  };

  const handle_opt_options_error = () => {
    handleToggleLoading(false);
  };

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    let array = [];
    let team_members = [...teamMembers];
    selectedUsers.forEach((user) => {
      array.push({
        user_id: user.Username,
        profile_img: user.picture || null,
        display_name: user.name
      });
    });
    team_members = team_members.map((member) =>
      selectedUsers.some((user) => user.user_id === member.user_id)
        ? { ...member, selected: true }
        : { ...member, selected: false }
    );
    setTeamMembers([...team_members]);
    dispatch(set_event_details({ ...event_details, participants: array }));
  }, [selectedUsers]);

  const formatStartTime = (timeDetails) => {
    const {
      hour: { value: hour },
      minutes: { value: minutes },
      type
    } = timeDetails;
    return `${
      (hour !== "" ? hour : "12") +
      ":" +
      (minutes !== "" ? minutes : "00") +
      " " +
      (type !== "" ? type : "AM")
    }`;
  };

  useEffect(() => {
    if (
      startTimeDetails.hour.value !== "" ||
      startTimeDetails.minutes.value !== "" ||
      startTimeDetails.type !== ""
    )
      dispatch(
        set_event_details({
          ...event_details,
          start_time: formatStartTime(startTimeDetails)
        })
      );
  }, [startTimeDetails]);

  useEffect(() => {
    if (
      endTimeDetails.hour.value !== "" ||
      endTimeDetails.minutes.value !== "" ||
      endTimeDetails.type !== ""
    )
      dispatch(
        set_event_details({
          ...event_details,
          end_time: formatStartTime(endTimeDetails)
        })
      );
  }, [endTimeDetails]);

  const handleBackClick = () => {
    history.push({
      pathname: "/outside_team_building"
    });
  };

  const handleDateChange = (date, type) => {
    // setEventDetails((prev) => {
    //   return type === "start"
    //     ? { ...prev, start_date: date }
    //     : { ...prev, end_date: date };
    // });
    dispatch(
      set_event_details(
        type === "start"
          ? { ...event_details, start_date: date }
          : { ...event_details, end_date: date }
      )
    );
  };

  const handleTitleChange = (value) => {
    dispatch(
      set_event_details({
        ...event_details,
        title: value
      })
    );
  };

  const isCreateValidate = () =>
    event_details.title !== "" &&
    event_details.type !== "" &&
    event_details.category !== "" &&
    event_details.start_timestamp !== "" &&
    event_details.end_timestamp !== "" &&
    !_.isEmpty(event_details.participants);

  // Handle Teammates Refresh
  // useEffect(() => {
  //   if (!_.isEmpty(users) && !_.isEmpty(event_details.participants)) {
  //     const selected_users = users.filter((user) => {
  //       return event_details.participants.some(
  //         (item) => item.user_id === user.Username
  //       );
  //     });
  //     setSelectedUsers(selected_users);
  //     const selected_members = users.map((user) => ({
  //       ...user,
  //       selected: event_details.participants.some(
  //         (item) => item.user_id === user.Username
  //       )
  //     }));
  //     setTeamMembers(selected_members);
  //   }
  // }, [users, event_details.participants]);

  // const handleCreateEvent = () => {
  //   if (isCreateValidate()) {
  //     handleToggleLoading(true);
  //     let data = {
  //       action: "opt-create",
  //       team_code: currentUser.team.id,
  //       user_id: currentUser.userId,
  //       title: event_details.title,
  //       type: event_details.type,
  //       category: event_details.category,
  //       start_timestamp: event_details.start_timestamp,
  //       end_timestamp: event_details.end_timestamp,
  //       participants: event_details.participants
  //     };
  //     Socket.sendMessage(data);
  //   }
  // };

  // const handleUpdateEvent = () => {
  //   if (isCreateValidate()) {
  //     handleToggleLoading(true);
  //     let data = {
  //       action: "opt-update",
  //       team_code: currentUser.team.id,
  //       opt_id: opt_details.opt_id,
  //       user_id: currentUser.userId,
  //       title: event_details.title,
  //       type: event_details.type,
  //       category: event_details.category,
  //       start_timestamp: event_details.start_timestamp,
  //       end_timestamp: event_details.end_timestamp,
  //       participants: event_details.participants
  //     };
  //     Socket.sendMessage(data);
  //   }
  // };

  useEffect(() => {
    if (event_details.start_date !== "" && event_details.start_time !== "") {
      const date = moment(event_details.start_date).format("MM/DD/YYYY");
      // setEventDetails((prev) => ({
      //   ...prev,
      //   start_timestamp: moment(`${date} ${event_details.start_time}`).valueOf()
      // }));
      dispatch(
        set_event_details({
          ...event_details,
          start_timestamp: moment(
            `${date} ${event_details.start_time}`
          ).valueOf()
        })
      );
    }
  }, [event_details.start_date, event_details.start_time]);

  useEffect(() => {
    if (event_details.end_date !== "" && event_details.end_time !== "") {
      const date = moment(event_details.end_date).format("MM/DD/YYYY");
      // setEventDetails((prev) => ({
      //   ...prev,
      //   end_timestamp: moment(`${date} ${event_details.end_time}`).valueOf()
      // }));
      dispatch(
        set_event_details({
          ...event_details,
          end_timestamp: moment(`${date} ${event_details.end_time}`).valueOf()
        })
      );
    }
  }, [event_details.end_date, event_details.end_time]);

  useEffect(() => {
    if (event_details.start_date !== "" && event_details.end_date !== "") {
      moment(event_details.end_date).isBefore(
        moment(event_details.start_date)
      ) &&
        dispatch(
          set_event_details({
            ...event_details,
            end_date: "",
            end_timestamp: ""
          })
        );
    }
  }, [event_details.start_date, event_details.end_date]);

  const handleToggleDropdown = (dropdownName) => {
    setDropdown((prevState) => {
      const updatedDropdown = {};
      Object.keys(prevState).forEach((key) => {
        updatedDropdown[key] = key === dropdownName ? !prevState[key] : false;
      });
      return updatedDropdown;
    });
  };

  const handleCustomEvent = (action, value) => {
    if (value !== "") {
      handleToggleLoading(true);
      const data = {
        action: "opt-options",
        team_code: currentUser.team.id,
        opt_action: action,
        opt_type: value
      };
      Socket.sendMessage(data);
    }
  };

  const handleDropDownText = () => {
    if (teamMembers.some((item) => item.selected)) {
      let array = teamMembers.filter((item) => item.selected);
      if (array.length === 1) {
        return `${array[0].name.trim()}`;
      } else if (array.length === 2) {
        return `${array[0].name.trim()}, ${array[1].name.trim()}`;
      } else {
        return `${array[0].name.trim()}, ${array[1].name.trim()}, +${
          array.length - 2
        } More`;
      }
    } else {
      return "Select Teammates";
    }
  };

  const handleUserClick = (user) => {
    const array = teamMembers.map((item) =>
      item.Username === user.Username
        ? { ...item, selected: !item.selected }
        : item
    );
    setTeamMembers(array);
  };

  const handleSaveTemmates = () => {
    if (!_.isEmpty(teamMembers)) {
      const array = teamMembers.filter((item) => item.selected);
      setSelectedUsers(array);
      setDropdown((prev) => ({ ...prev, select_teammates: false }));
    }
  };

  return (
    <div className="opt-event">
      {/* Challenge Progress */}
      <div className="progress-parent">
        <div className="top-div">
          <div className="text-div">
            <h2 className="event-top-text-1">{`${
              _.isEmpty(opt_details) ? primary_text_add : primary_text_edit
            }`}</h2>
            <h2 className="event-top-text-2">
              {`${
                _.isEmpty(opt_details)
                  ? "Build and deploy custom surveys right to your team."
                  : secondary_text_edit
              }`}
            </h2>
          </div>
          {/* <div className="btn-div">
            <div className="back-button back" onClick={handleBackClick}>
              {back_btn}
            </div>
            <div
              className={`back-button create ${
                isCreateValidate() ? "enabled" : ""
              }`}
              onClick={() =>
                _.isEmpty(opt_details)
                  ? handleCreateEvent()
                  : handleUpdateEvent()
              }
            >
              {_.isEmpty(opt_details) ? create_btn : save_btn}
            </div>
          </div> */}
        </div>

        <div className="event-progress">
          <div className="progress-div">
            <div className="circle filled">
              <h2 className="progress-text completed">1. Event Details</h2>
            </div>
            <div
              className={`line ${create_opt_phase === "two" ? "filled" : ""}`}
            ></div>
            <div
              className={`circle ${
                create_opt_phase === "two" ? "filled" : "empty"
              }`}
            >
              <h2
                className={`progress-text last ${
                  create_opt_phase === "two" ? "completed" : ""
                }`}
              >
                2. Invite Participants
              </h2>
            </div>
          </div>
        </div>
        {/* <div className="challange-progress">
          <div className="col-12">
            <ul id="progressbar" className="text-center">
              <li className="step 0 active"></li>
              <li className="step0"></li>
            </ul>
          </div>
        </div>
        <div className="challange-progress-text">
          <div className="box">
            <p className="font-weight-bold">Build Challenge</p>
          </div>
          <div className="box">
            <p className="font-weight-bold">Challenge Settings</p>
          </div>
        </div> */}
      </div>

      {/* Event Details */}
      {create_opt_phase === "one" && (
        <div
          className={`opt-event-data ${
            dropdown.event_type || dropdown.event_category ? "bottom-space" : ""
          }`}
        >
          <h3 className="heading">Event Details</h3>
          <p className="desc">
            Add a new event, record participation, and filters for reporting.{" "}
          </p>
          <input
            type="text"
            value={event_details.title}
            className="event-title"
            placeholder={title_hint}
            onChange={(e) => handleTitleChange(e.target.value)}
          />

          <div className="date-container">
            <h2 className="duration-label">{duration_text}</h2>
            <div className="date-container-1">
              {/* Start Date */}
              <div
                className={`date-div ${dropdown.start_date ? "selected" : ""}`}
                onClick={() => handleToggleDropdown("start_date")}
              >
                <span className="date-label">{`${
                  event_details.start_date === ""
                    ? start_date_hint
                    : moment(event_details.start_date).format("MM/DD/YYYY")
                }`}</span>
                <DownArrowSvg className="date-dropdown-arrow" />
                {dropdown.start_date && (
                  <div
                    onClick={(e) => e.stopPropagation()}
                    className="day-picker-main"
                  >
                    <DayPicker
                      mode="single"
                      required
                      selected={new Date(event_details.start_date)}
                      onSelect={(date) => {
                        handleDateChange(date, "start");
                        handleToggleDropdown("start_date");
                      }}
                      className="calender-months"
                      fromDate={undefined}
                    />
                  </div>
                )}
              </div>

              {/* Start Time */}
              <div
                className={`date-div time ${
                  dropdown.start_time ? "selected" : ""
                }`}
                onClick={() => handleToggleDropdown("start_time")}
              >
                <span className="date-label">
                  {event_details.start_time === ""
                    ? start_time_hint
                    : event_details.start_time}
                </span>
                <DownArrowSvg className="date-dropdown-arrow" />
                {dropdown.start_time && (
                  <TimePicker
                    timeDetails={startTimeDetails}
                    setTimeDetails={setStartTimeDetails}
                  />
                )}
              </div>
            </div>

            <div className="date-container-1 second-div">
              {/* End Date */}
              <div
                className={`date-div ${dropdown.end_date ? "selected" : ""}`}
                onClick={() => handleToggleDropdown("end_date")}
              >
                <span className="date-label">{`${
                  event_details.end_date === ""
                    ? end_date_hint
                    : moment(event_details.end_date).format("MM/DD/YYYY")
                }`}</span>
                <DownArrowSvg className="date-dropdown-arrow" />
                {dropdown.end_date && (
                  <div
                    onClick={(e) => e.stopPropagation()}
                    className="day-picker-main"
                  >
                    <DayPicker
                      mode="single"
                      required
                      selected={new Date(event_details.end_date)}
                      onSelect={(date) => {
                        handleDateChange(date);
                        handleToggleDropdown("end_date");
                      }}
                      className="calender-months"
                      fromDate={
                        event_details.start_date !== ""
                          ? event_details.start_date
                          : undefined
                      }
                    />
                  </div>
                )}
              </div>

              {/* End Time */}
              <div
                className={`date-div time ${
                  dropdown.end_time ? "selected" : ""
                }`}
                onClick={() => handleToggleDropdown("end_time")}
              >
                <span className="date-label">
                  {event_details.end_time === ""
                    ? end_time_hint
                    : event_details.end_time}
                </span>
                <DownArrowSvg className="date-dropdown-arrow" />
                {dropdown.end_time && (
                  <TimePicker
                    timeDetails={endTimeDetails}
                    setTimeDetails={setEndTimeDetails}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="horizontal-divider" />

          <div className="date-container event-details">
            <h2 className="duration-label">{details_text}</h2>
            <div className="date-container-1">
              <div
                className={`date-div ${dropdown.event_type ? "selected" : ""}`}
                onClick={() => handleToggleDropdown("event_type")}
              >
                <span className="date-label">
                  {event_details.type !== "" ? event_details.type : type_hint}
                </span>
                <DownArrowSvg className="date-dropdown-arrow" />
                {dropdown.event_type && (
                  <div
                    onClick={(e) => e.stopPropagation()}
                    className="event-type-dropdown"
                  >
                    <div className="event-type-inner type">
                      {type_array.map((item, index) => (
                        <div
                          key={index}
                          className="type-main"
                          onClick={() => {
                            dispatch(
                              set_event_details({
                                ...event_details,
                                type: item
                              })
                            );
                            handleToggleDropdown("event_type");
                          }}
                        >
                          {item}
                        </div>
                      ))}
                      {/* Custom Event */}
                      {!_.isEmpty(custom_opt_types) && (
                        <div className="custom-event-opt">
                          <div className="custom-div">Custom:</div>
                          {custom_opt_types.map((opt, index) => (
                            <div
                              key={index}
                              className="opt-div"
                              onClick={() => {
                                dispatch(
                                  set_event_details({
                                    ...event_details,
                                    type: opt
                                  })
                                );
                                handleToggleDropdown("event_type");
                              }}
                            >
                              {opt}
                              <DeleteTypeSvg
                                className="remove-type-icon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCustomEvent("Delete", opt);
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      )}
                      <div className="other-event">
                        <h2 className="other-text">{other_text}</h2>
                        <input
                          type="text"
                          value={customEventType}
                          placeholder={other_input}
                          className="event-type-add"
                          onChange={(e) => setCustomEventType(e.target.value)}
                        />
                        <AddTypeSvg
                          className="add-type-icon"
                          onClick={() =>
                            handleCustomEvent("Add", customEventType)
                          }
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className={`date-div ${
                  dropdown.event_category ? "selected" : ""
                }`}
                onClick={() => handleToggleDropdown("event_category")}
              >
                <span className="date-label">
                  {event_details.category !== ""
                    ? event_details.category
                    : category_hint}
                </span>
                <DownArrowSvg className="date-dropdown-arrow" />
                {dropdown.event_category && (
                  <div
                    onClick={(e) => e.stopPropagation()}
                    className="event-type-dropdown"
                  >
                    <div className="event-type-inner">
                      {categories_array.map((item, index) => (
                        <div
                          className="type-main"
                          key={index}
                          onClick={() => {
                            dispatch(
                              set_event_details({
                                ...event_details,
                                category: item
                              })
                            );
                            handleToggleDropdown("event_category");
                          }}
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="horizontal-divider" />
        </div>
      )}

      {/* Manage Participants */}
      {create_opt_phase === "two" && (
        <section className="manage-teammates">
          <h3 className="heading">Manage Teammate(s)</h3>
          <p>Select one or more teams to participate in your Event.</p>
          <div className="manage-teammates__flex">
            <div
              className={`date-div ${
                dropdown.select_teammates ? "selected" : ""
              }`}
              onClick={() => handleToggleDropdown("select_teammates")}
            >
              {/* <span className="date-label">
                {event_details.start_time === ""
                  ? start_time_hint
                  : event_details.start_time}
              </span> */}
              <span className="label">{handleDropDownText()}</span>
              <DownArrowSvg className="date-dropdown-arrow" />
              {dropdown.select_teammates && (
                <div
                  onClick={(e) => e.stopPropagation()}
                  className="dropdown-main"
                >
                  {teamMembers.map((user, index) => (
                    <div
                      className="dropdown-item"
                      key={index}
                      onClick={() => handleUserClick(user)}
                    >
                      {user.selected ? (
                        <CheckBoxEnabledSvg className="checkbox" />
                      ) : (
                        <CheckBoxDisabledSvg className="checkbox" />
                      )}
                      {user.picture ? (
                        <img alt="" src={user.picture} className="avatar" />
                      ) : (
                        <DummyAvatarSvg className="avatar" />
                      )}
                      <h2>{user.name}</h2>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <button className="save-btn" onClick={handleSaveTemmates}>
              Save
            </button>
          </div>
        </section>
      )}

      {/* Participants */}
      {create_opt_phase === "two" && (
        <div className="date-container participants">
          <div className="header-div">
            <h2 className="duration-label participants">{participants_text}</h2>
            {/* <div className="add-teammates-btn" onClick={onTeamModalOpen}>
              {add_teammates_btn}
            </div> */}
          </div>

          {_.isEmpty(selectedUsers) ? (
            <div className="participants-empty">
              <BroSvg className="bro-image" />
              <h2 className="empty-text">
                No Teammates to display. <span>Add Teammates</span> to
                participate in your Event.
              </h2>
            </div>
          ) : (
            <div className="participants-main">
              <div className="participants-list">
                <div className="list-cell header">{table_col_1}</div>
                <div className="list-cell header">{table_col_2}</div>
                <div className="list-cell header">{table_col_3}</div>
                {/* <div className="list-cell header">Last Active</div> */}
                <div className="last-div"></div>
              </div>
              <div className="participants-list-main">
                {selectedUsers.map((user, index) => (
                  <div key={index} className="participants-list">
                    <div className="list-cell highlight">
                      {user.picture ? (
                        <img alt="" src={user.picture} className="avatar" />
                      ) : (
                        <DummyAvatarSvg className="avatar" />
                      )}
                      {user.name}
                    </div>
                    <div className="list-cell">{user.email}</div>
                    <div className="list-cell">
                      {user.sub_team !== undefined
                        ? user.sub_team
                        : default_text}
                    </div>
                    {/* <div className="list-cell">Data Entry</div> */}
                    <div
                      className="delete-div"
                      onClick={() => onDeleteModalOpen(user)}
                    >
                      <DeleteIconSvg className="delete-div-icon" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AddEvent;
